import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import ShadeModal from "../../core/modals/shade/ShadeModal";
import { fetchShades, deleteShadeThunk } from "../../core/redux/slices/shadeSlice";

const ShadeList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.shade);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchShades()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((s) => !q || s.shadeName?.toLowerCase().includes(q));
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchShades()); };

  const columns = [
    { title: "Shade Name", dataIndex: "shadeName", sorter: (a, b) => a.shadeName.localeCompare(b.shadeName) },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteShadeThunk(rec.id)), rec.shadeName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Shade" subtitle="Manage shade master list" onAdd={openAdd} addLabel="Add Shade" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-input">
                <input type="text" placeholder="Search shade..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <ShadeModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default ShadeList;
